import { useEffect, useRef } from 'react';
import { ImageComponent } from '@/components/Image';
import { isCdnImg } from '@/modules/promo';
import type { ITopGamesProps } from '..';

export interface ITopGamesSliderProps
  extends Pick<ITopGamesProps, 'isWheelScroll' | 'srcImgs'> {
  images: string[];
  size: number;
}
export const TopGamesSlide = ({
  images,
  size,
  srcImgs,
  isWheelScroll,
}: ITopGamesSliderProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isWheelScroll) return;
    const el = containerRef.current;
    if (!el) return;
    const onWheel = (e: WheelEvent) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };
    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, [isWheelScroll]);

  const imgSrc = (src: string) => {
    if (isCdnImg(src)) {
      return src;
    }
    return `${srcImgs ? srcImgs : '/lp/banks-benefits/top-games/'}${src}.webp`;
  };

  return (
    <div className="image-wrapper" ref={containerRef}>
      {images.map((item) => (
        <ImageComponent
          alt={item.toString()}
          className="image"
          height={size}
          key={item}
          src={imgSrc(item)}
          width={size}
        />
      ))}
    </div>
  );
};
